// extracted by mini-css-extract-plugin
export default {"wrapper":"tw-z","button":"uw-z","alternate":"vw-z","disabled":"ww-z","paymentWarning":"xw-z","fadeIn":"yw-z"};